const DocType = {
  PO_FILE: 'PO_FILE',
  INV_FILE: 'INV_FILE',
  MRT_FILE: 'MRT_FILE',
  DOCS_FILE: 'DOCS_FILE',
};

export default DocType;
